
export function getRegisteredDomain(url) {
  try{

    const hostname = new URL(url).hostname;
    return getBaseDomain( hostname )
  }catch(e){
    return undefined 
  }
}
export function extractHashtags(str = "") {
  const hashtags = [];
  // Match: any spaces/commas/semicolons before the #tag, then the #tag, then any after
  const cleaned = str.replace(/[\s,;]*#(\w+)[\s,;]*/g, (match, tag) => {
    hashtags.push('#' + tag);
    return ' ';        // replace the whole match with a single space
  })
  // collapse multiple spaces into one, then trim ends
  .replace(/\s{2,}/g, ' ')
  .trim();

  return { text: cleaned, hashtags };
}

export function pickAtRandom(input, count) {
  const out = [];
  const used = new Set();
  const n = input.length;

  count = Math.min(count, n);

  while (out.length < count && used.size < n) {
    const idx = Math.floor(Math.random() * n);
    if (!used.has(idx)) {
      used.add(idx);
      out.push(input[idx]);
    }
  }
  return out;
}
export function isObjectId(id){
  return /^[0-9a-fA-F]{24}$/.test(id);
}
export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
export function roundCurrency(number){
    if(number === 0){
        return "$0"
    }
    if( isNaN(number)){
        return "-"
    }
    let prefix = "$"
    if( number < 0){
        prefix = "-$"
        number = -number
    }

    return prefix + formatNumber(number)
}
export function getBaseDomain(hostname) {
  const parts = hostname.split('.');
  const len = parts.length;

  // Common second-level labels under country TLDs:
  const SLD = new Set(['co','com','net','org','gov','edu','ac','mil','sch']);

  // If it ends in e.g. “.co.uk” (2-letter country + known SLD), grab last 3 parts:
  if (len >= 3 
      && parts[len-1].length === 2 
      && SLD.has(parts[len-2].toLowerCase())
  ) {
    return parts.slice(-3).join('.');
  }

  // Otherwise just take last 2 parts:
  return parts.slice(-2).join('.');
}

export function cleanURL(url){
   // Trim whitespace from the input
   let cleanedUrl = url.trim();

   // Check if the URL has a protocol, if not, add "https://"
   if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(cleanedUrl)) {
       cleanedUrl = "https://" + cleanedUrl;
   }

   return cleanedUrl;
}

export function normaliseDomain(domain) {
  if (!domain) {
    return undefined;
  }

  try {
    const cleaned = cleanURL(domain.trim());
    const url = new URL(cleaned);
    return getBaseDomain(url.hostname);
  } catch (err) {
    const stripped = domain.replace(/^(https?:\/\/)/i, '').split('/')[0];
    return getBaseDomain(stripped);
  }
}

export function expandStringLiterals(text, literals = {}){
  const matches = text.match(/\{([^}]+)\}/g).map(d=>d.slice(1,-1)).filter((d,i,a)=>a.indexOf(d)===i);
  for(const fm of matches){
    let [m,mod] = fm.split("_")
    let item = literals[m]
    if( typeof(item) === "object" && item.data){
      item = item.data
    }
    let textItem = item
    if( Array.isArray(item)){
      const oArray = []
      for(const d of item){
        if( typeof(d)==="object"){
          if( d.type === "summary"){
            oArray.push( d.referenceParameters?.summary ?? "")
          }else{
            oArray.push( d.title ?? "")
          }
        }else{
          oArray.push( d )
        }
      }
      if( mod === "count"){
        textItem = oArray.length
      }else{
        textItem = oArray.join(". ")
      }
    }
    text = text.replaceAll(`{${fm}}`, textItem ?? "")
  }
  return text

}
export function baseURL(url) {
  // Clean the URL first
  const cleanedUrl = cleanURL(url);

  // Use URL constructor to parse and extract the base URL
  try {
      const parsedUrl = new URL(cleanedUrl);
      // Combine protocol and hostname
      return `${parsedUrl.protocol}//${parsedUrl.hostname}`;
  } catch (error) {
      throw new Error("Invalid URL");
  }
}

export function formatNumber(number){
    if(number === 0){
        return "0"
    }
    if( isNaN(number)){
        return "-"
    }
    const sign = number < 0 ? "-" : ""
    const absVal = Math.abs(number)

    // Small numbers: show as plain decimals without suffix
    if( absVal < 1 ){
        // show up to 2 decimals, trim trailing zeros and dot
        return sign + (absVal.toFixed(2).replace(/\.0+$/,'').replace(/\.$/,''))
    }

    const suffixes = ["", " K", " M"," B"," T"];
    const rawIndex = Math.floor(Math.log10(absVal) / 3)
    const suffixIndex = Math.max(0, Math.min(suffixes.length - 1, rawIndex))

    const scaledNumber = absVal / Math.pow(10, suffixIndex * 3);
    let formattedNumber = scaledNumber.toFixed( suffixIndex > 1 ? 1 : 2);
    formattedNumber = formattedNumber.replace(/\.0+$/, '').replace(/\.00$/, '').replace(/\.$/,'');

    return sign + formattedNumber + (suffixes[suffixIndex] ?? "");
}
export function markdownToSlate(markdownContent = "") {
  const lines = markdownContent.split(/\r?\n/);
  const slateNodes = [];

  // For nested lists:
  const listStack = []; // { node, indent, type }

  // For tables:
  let currentTable = null;
  let postTableText 
  let isInTable    = false;

  const flushLists = () => {
    listStack.length = 0;
  };
  const hasMeaningfulInlineContent = (nodes = []) => {
    for (const node of nodes) {
      if (!node) continue;
      if (typeof node.text === "string" && node.text.trim()) {
        return true;
      }
      if (node.type === "badge") {
        return true;
      }
      if (node.children && hasMeaningfulInlineContent(node.children)) {
        return true;
      }
    }
    return false;
  };

  const appendTop = (node) => {
    if (listStack.length) {
      listStack[listStack.length - 1].node.children.push(node);
    } else {
      slateNodes.push(node);
    }
  };
  const getTableProbeText = (rawLine = "") => {
    const trimmedLine = rawLine.trim();
    const listMatch = trimmedLine.match(/^([-*]|\d+\.)\s+(.*)$/);
    return (listMatch ? listMatch[2] : trimmedLine);
  };
  const hasNearFrontPipe = (text = "") => {
    if (!text.includes("|")) {
      return false;
    }
    if (text.startsWith("|")) {
      return true;
    }
    const idx = text.indexOf("|");
    return idx >= 0 && idx <= 3;
  };
  const nextNonEmptyLine = (startIndex) => {
    for (let i = startIndex; i < lines.length; i++) {
      const candidate = lines[i] ?? "";
      if (candidate.trim()) {
        return candidate;
      }
    }
    return null;
  };
  const normalizeTableCellText = (raw = "") =>
    raw.replace(/<br\s*\/?>/gi, "\n");
  const buildTableCell = (content = "") => {
    const normalized = normalizeTableCellText(content);
    // Parse full markdown blocks inside table cells so headings/lists render
    // as structured nodes instead of plain inline text.
    const parsed = markdownToSlate(normalized);
    const paragraphs = (Array.isArray(parsed) ? parsed : [])
      .filter((node) => node && node.type !== "table");
    if (!paragraphs.length) {
      paragraphs.push({
        type: "paragraph",
        children: [{ text: "" }],
      });
    }
    return {
      type: "table-cell",
      children: paragraphs,
    };
  };
  const ensureTableWidth = (table, observedColumns) => {
    if (!table || observedColumns <= 0) {
      return;
    }
    const expectedColumns = Math.max((table.expectedPipeCount ?? 1) - 1, 0);
    if (observedColumns <= expectedColumns) {
      return;
    }
    const missingColumns = observedColumns - expectedColumns;
    if (table.children?.[0]?.isHeader) {
      const fillers = [];
      for (let i = 0; i < missingColumns; i++) {
        fillers.push(buildTableCell());
      }
      table.children[0].children = fillers.concat(table.children[0].children);
    }
    table.expectedPipeCount = observedColumns + 1;
  };
  let rowBuffer = ""
  let rowPipeCount = 0
  let nextRowBuffer = ""
  let nextPipeCount = 0

  let lineCount = lines.length
  for (let lineNumber = 0; lineNumber < lineCount; lineNumber++) {
    let raw = lines[lineNumber] ?? ""
    if( isInTable ){
      if( currentTable && ((rowPipeCount >0 ||raw[0] === "|") && rowPipeCount < currentTable.expectedPipeCount) ){
        let cols = raw.split("|")
        const isHeaderSep = cols.length > 1 && cols.slice(1, -1).every(c => /^-+$/.test(c));
        if( !isHeaderSep ){
          const pipes = cols.length  - 1
          if( rowPipeCount > 1 && raw.startsWith("|")){
            nextRowBuffer = raw
            nextPipeCount = pipes
            raw = rowBuffer 
            if( raw.at(-1) !== "|"){
              raw += "|"
            }
            if( lineNumber === (lineCount - 1)){
              lineCount++
            }
          }else{
            rowBuffer += (rowBuffer !== "" ? "\n" : "") + raw
            //rowBuffer += raw
            rowPipeCount += pipes
            if( currentTable?.expectedPipeCount && rowPipeCount > currentTable.expectedPipeCount ){
              ensureTableWidth(currentTable, Math.max(rowPipeCount - 1, 0))
            }
            if(rowPipeCount == currentTable.expectedPipeCount ){
              nextRowBuffer = ""
              nextPipeCount = 0
              raw = rowBuffer 
            }else if( lineNumber === (lineCount - 1)){
              raw = rowBuffer 
              if( raw.at(-1) !== "|"){
                raw += "|"
              }
            }else{
              continue
            }
          }
        }
      }
    }
    const line    = raw.replace(/\r$/, "");
    let trimmed = line.trim();

    // 1) Continuation of last <li>?
    const cont = raw.match(/^(\s+)(\S.*)/);
    if (cont && listStack.length) {
      const [, , text] = cont;
      if (!/^(\d+\.)\s|^[-*]\s/.test(text)) {
        const topList  = listStack[listStack.length - 1].node;
        const lastItem = topList.children[topList.children.length - 1];
        const target = lastItem.children[lastItem.children.length - 1];
        if (target?.type === "paragraph") {
          target.children.push({ text: "\n" });
          target.children.push(...parseInlineWithBadges(text));
        } else {
          lastItem.children.push({
            type: "paragraph",
            children: parseInlineWithBadges(text),
          });
        }
        continue;
      }
    }

    // 2) Table rows
    const tableProbe = getTableProbeText(raw);
    const hasPipe = tableProbe.includes("|");
    const pipeNearFront = hasNearFrontPipe(tableProbe);
    const shouldTreatAsTableRow = hasPipe && (
      isInTable ||
      pipeNearFront ||
      (() => {
        const nextLine = nextNonEmptyLine(lineNumber + 1);
        if (!nextLine) {
          return false;
        }
        const nextProbe = getTableProbeText(nextLine);
        return hasNearFrontPipe(nextProbe);
      })()
    );
    if (shouldTreatAsTableRow) {
      trimmed = tableProbe.trim();
      // break out of any open lists
      flushLists();

      if( isInTable ){
        if( trimmed.at(-1) !== "|" && rowPipeCount === currentTable.expectedPipeCount){
          const pos = trimmed.lastIndexOf("|")
          postTableText = trimmed.slice(pos + 1)
          trimmed = trimmed.slice(0, pos + 1)
        }
      }

      // split out the cells
      let cols = trimmed.split("|");
      const hasLeading = trimmed.startsWith("|");
      const hasTrailing = trimmed.endsWith("|");
      if (hasLeading) {
        cols.shift();
      }
      if (hasTrailing) {
        cols.pop();
      }
      if (cols.length === 1 && currentTable?.expectedPipeCount) {
        const cellsNeeded = Math.max(currentTable.expectedPipeCount - 1, 1);
        const expanded = new Array(cellsNeeded).fill("");
        expanded[0] = cols[0];
        cols = expanded;
      } else if (!isInTable && !currentTable && trimmed.includes("| | |")) {
        // heuristic: assume table if input contains space-separated pipes but parser hasn't started yet
        const cleaned = trimmed.split("|").map(c => c.trim());
        cols = cleaned;
      }
      cols = cols.map(c => c.trim());

      // header-separator row?
      const isHeaderSep = cols.every(c => /^-+$/.test(c));
      if (!isHeaderSep && isInTable && currentTable) {
        ensureTableWidth(currentTable, cols.length);
      }
      if (isHeaderSep) {
        if (currentTable && currentTable.children.length) {
          currentTable.children[0].isHeader = true;
          rowBuffer = nextRowBuffer
          rowPipeCount = nextPipeCount
        }
        continue;
      }

      // build the row
      const row = {
        type: "table-row",
        children: cols.map(c => buildTableCell(c)),
      };

      if (isInTable) {
        if (cols.length < currentTable.expectedPipeCount - 1) {
          cols = cols.concat(new Array(currentTable.expectedPipeCount - 1 - cols.length).fill(""));
          row.children = cols.map(c => buildTableCell(c));
        }
        currentTable.children.push(row);
        rowPipeCount = nextPipeCount
        rowBuffer = nextRowBuffer
      } else {
        currentTable = { type: "table", children: [row] };
        slateNodes.push(currentTable);
        isInTable = true;
          currentTable.expectedPipeCount = row.children.length + 1;
          rowBuffer = nextRowBuffer
          rowPipeCount = nextPipeCount
      }
      continue;
    } else {
      isInTable = false;
      if( postTableText ){
        slateNodes.push({
          type: "paragraph",
          children: parseInlineWithBadges(postTableText),
        });
        postTableText = undefined
      }
    }

    // 3) Headings
    const h = trimmed.match(/^(#+)\s+(.*)$/);
    if (h) {
      flushLists();
      const level = Math.min(Math.max(h[1].length, 1), 6);
      slateNodes.push({
        type: "heading",
        level,
        children: parseInlineWithBadges(h[2]),
      });
      continue;
    }

    // 4) Lists
    const mOrdered   = raw.match(/^(\s*)(\d+\.)\s+(.*)$/);
    const mUnordered = !mOrdered && raw.match(/^(\s*)([-*])\s+(.*)$/);
    if (mOrdered || mUnordered) {
      const [, indentSpaces, marker, rest] = mOrdered || mUnordered;
      const indentCount = indentSpaces.length;
      const isOrdered   = !!mOrdered;
      const listType    = isOrdered ? "ordered-list" : "unordered-list";
      const itemContent = parseInlineWithBadges(rest);
      if (!hasMeaningfulInlineContent(itemContent)) {
        continue;
      }
      const wrappedItem = {
        type: "list-item",
        children: [
          { type: "paragraph", children: itemContent }
        ]
      };

      // capture explicit start if “3.” etc.
      const explicitStart = isOrdered
        ? parseInt(marker.slice(0, -1), 10)
        : undefined;

      // a) deeper indent → nested list under last <li>
      if (
        listStack.length &&
        indentCount > listStack[listStack.length - 1].indent
      ) {
        const parentList = listStack[listStack.length - 1].node;
        const parentItem = parentList.children[parentList.children.length - 1];
        const nestedList = { type: listType, children: [] };
        if (isOrdered && explicitStart > 1) nestedList.start = explicitStart;
        parentItem.children.push(nestedList);
        listStack.push({ node: nestedList, indent: indentCount, type: listType });
        //nestedList.children.push({ type: "list-item", children: itemContent });
        nestedList.children.push( wrappedItem )
        continue;
      }

      // b) pop deeper/mismatched
      while (listStack.length) {
        const top = listStack[listStack.length - 1];
        if (
          top.indent > indentCount ||
          (top.indent === indentCount && top.type !== listType)
        ) {
          listStack.pop();
        } else {
          break;
        }
      }

      // c) same list container → append
      if (
        listStack.length &&
        listStack[listStack.length - 1].indent === indentCount &&
        listStack[listStack.length - 1].type === listType
      ) {
        const existing = listStack[listStack.length - 1].node;
        //existing.children.push({ type: "list-item", children: itemContent });
        existing.children.push( wrappedItem )
        continue;
      }

      // d) new list container
      const newList = { type: listType, children: [] };
      if (isOrdered && explicitStart > 1) newList.start = explicitStart;
      appendTop(newList);
      listStack.push({ node: newList, indent: indentCount, type: listType });
      newList.children.push( wrappedItem )
      //newList.children.push({ type: "list-item", children: itemContent });
      continue;
    }

    // 5) Paragraph / blank
    flushLists();
    if (trimmed) {
      slateNodes.push({
        type: "paragraph",
        children: parseInlineWithBadges(trimmed),
      });
    } else {
      slateNodes.push({
        type: "paragraph",
        children: [{ text: "" }],
      });
    }
  }

      if( postTableText ){
        slateNodes.push({
          type: "paragraph",
          children: parseInlineWithBadges(postTableText),
        });
      }

  // ensure at least one node
  return slateNodes.length
    ? slateNodes
    : [{ type: "paragraph", children: [{ text: "" }] }];
}

  
  export function parseMarkdownText(text){
    const lines = text.split('\n');
    const nodes = [];
  
    lines.forEach((line) => {
      const trimmedLine = line.trim();
  
      // Handle headers
      if (trimmedLine.startsWith('#')) {
        const headingMatch = trimmedLine.match(/^(#+)\s*(.*)/);
  
        if (headingMatch) {
          const headingLevel = headingMatch[1].length;
          const headingText = headingMatch[2];
  
          // Ensure the heading level is between 1 and 6 (HTML heading levels)
          const validHeadingLevel = Math.min(Math.max(headingLevel, 1), 6);
  
          nodes.push({
            type: 'heading',
            level: validHeadingLevel, // Add the heading level to the node
            children: parseInlineWithBadges(headingText),
          });
        }
        return;
      }
  
      // Handle ordered list items (e.g., "1. Item")
      const orderedListMatch = line.match(/^(\s*)(\d+\.)\s+(.*)/);
      if (orderedListMatch) {
        const indentLevel = Math.floor(orderedListMatch[1].length / 2); // Two spaces per indent level
        const content = parseInlineWithBadges(orderedListMatch[3]);
  
        nodes.push({
          type: 'ordered-list',
          children: [
            {
              type: 'list-item',
              indentLevel: indentLevel,
              children: content,
            },
          ],
        });
        return;
      }
  
      // Handle unordered list items (e.g., "- Item")
      const unorderedListMatch = line.match(/^(\s*)(-|\*)\s+(.*)/);
      if (unorderedListMatch) {
        const indentLevel = Math.floor(unorderedListMatch[1].length / 2); // Two spaces per indent level
        const content = parseInlineWithBadges(unorderedListMatch[3]);
  
        const wrappedContent = wrapInNestedLists('unordered-list', content, indentLevel);
  
        nodes.push(wrappedContent);
        return;
      }
  
      // Handle paragraphs
      if (trimmedLine) {
        nodes.push({
          type: 'paragraph',
          children: parseInlineWithBadges(trimmedLine),
        });
      } else {
        // Handle blank lines by adding an empty paragraph node
        nodes.push({
          type: 'paragraph',
          children: [{ text: '' }],
        });
      }
    });
    
  
    return nodes;
  };

function parseInlineWithBadges(text) {
    const RE = /(\[\[([^\]]+)\]\]|\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))/g;
    const parts = [];
    let lastIndex = 0;
    let m;
  
    while ((m = RE.exec(text)) !== null) {
      const [fullMatch, , badgeType, linkLabel, linkUrl] = m;
      if (m.index > lastIndex) {
        parts.push(...parseMarkdownInline(text.slice(lastIndex, m.index)));
      }
      if (badgeType) {
        const isRef = badgeType.startsWith('ref:');

        if (isRef) {
          parts.push({ type: 'line-break', children: [{ text: '' }] });
        }
        parts.push({
          type: 'badge',
          badgeType,
          children: [{ text: '' }],
        });
      }
      else if (linkLabel && linkUrl) {
        parts.push({
          type: 'link',
          url: linkUrl,
          children: parseMarkdownInline(linkLabel),
        });
      }
      lastIndex = m.index + fullMatch.length;
    }
  
    if (lastIndex < text.length) {
      parts.push(...parseMarkdownInline(text.slice(lastIndex)));
    }
  

   const final = [];
    for (let i = 0; i < parts.length; i++) {
      const chunk = parts[i];
      if (chunk.text && chunk.text.includes('\n')) {
        const segments = chunk.text.split('\n');
        segments.forEach((seg, idx) => {
          if (seg) final.push({ type:"paragraph", ...chunk, text: seg });
        });
      } else {
        final.push(chunk);
      }
    }
  
    return final.length ? final : [{ text: '' }];

}
  
export function parseMarkdownInline(text){
    const tokens = [];
    let i = 0;
  
    while (i < text.length) {
      if (text.startsWith('**', i)) {
        // Bold text
        const endIndex = text.indexOf('**', i + 2);
        if (endIndex !== -1) {
          tokens.push({
            text: text.substring(i + 2, endIndex),
            bold: true,
          });
          i = endIndex + 2;
        } else {
          // No matching closing **
          tokens.push({ text: text.substring(i) });
          break;
        }
      } else if (text.startsWith('__', i)) {
        const endIndex = text.indexOf('__', i + 2);
        if (endIndex !== -1) {
          tokens.push({
            text: text.substring(i + 2, endIndex),
            bold: true,
          });
          i = endIndex + 2;
        } else {
          tokens.push({ text: text.substring(i) });
          break;
        }
      } else if (text.startsWith('_', i)) {
        const endIndex = text.indexOf('_', i + 1);
        if (endIndex !== -1) {
          tokens.push({
            text: text.substring(i + 1, endIndex),
            italic: true,
          });
          i = endIndex + 1;
        } else {
          tokens.push({ text: text.substring(i) });
          break;
        }
      } else if (text.startsWith('*', i)) {
        // Italic text
        const endIndex = text.indexOf('*', i + 1);
        if (endIndex !== -1) {
          tokens.push({
            text: text.substring(i + 1, endIndex),
            italic: true,
          });
          i = endIndex + 1;
        } else {
          // No matching closing *
          tokens.push({ text: text.substring(i) });
          break;
        }
      } else if (text.startsWith('`', i)) {
        // Code
        const endIndex = text.indexOf('`', i + 1);
        if (endIndex !== -1) {
          tokens.push({
            text: text.substring(i + 1, endIndex),
            code: true,
          });
          i = endIndex + 1;
        } else {
          // No matching closing `
          tokens.push({ text: text.substring(i) });
          break;
        }
      } else {
        // Plain text
        let nextSpecialIndex = text.length;
        //const specialChars = ['*', '_', '`'];
        const specialChars = ['*', '_', '`'];
        specialChars.forEach((char) => {
          const index = text.indexOf(char, i);
          if (index !== -1 && index < nextSpecialIndex) {
            nextSpecialIndex = index;
          }
        });
        tokens.push({
          text: text.substring(i, nextSpecialIndex),
        });
        i = nextSpecialIndex;
      }
    }
    if( tokens.length === 0){
          tokens.push({ text: "" });

    }
  
    return tokens;
  };
  
  export function wrapInNestedLists(listType, content, indentLevel){
    let wrappedContent = {
      type: 'list-item',
      children: content,
    };
    
  
    for (let i = 0; i < (indentLevel ?? 1); i++) {
      wrappedContent = {
        type: listType,
        children: [wrappedContent],
      };
    }
  
    return wrappedContent;
  };

export function convertOrganizationFinancialData( primitive, analysisTables, sections){
    let overall = ""
    let tables = 0
    sections = [sections].flat()

    for(const section of sections){
        let data = primitive.financialData?.[section]
        if( !data || Object.keys(data).length === 0){
            continue
        }
        const sectionInfo = analysisTables[section]

        let out = ""
        let validRows = 0
        if( sectionInfo.sourceType === "list"){
            const rows = Object.keys(data)
            for(const rowName of rows){
                if( data[rowName]){
                    out += "|" + (sectionInfo.rows?.[rowName] ?? rowName)+ "|" + data[rowName] + "|\n"
                    validRows++
                }
            }
        }else{
            if( Array.isArray(data)){
                data = data.reduce((a,c)=>{
                    a[c.Breakdown] = c.value
                    return a
                }, {})
            }
            let rows = Object.keys(data)
            if(sectionInfo.skipMissing && sectionInfo.rows){
                rows = rows.filter(d=>sectionInfo.rows[d])  
            }
            if( sectionInfo.rows){
                const order = Object.keys(sectionInfo.rows)
                rows = rows.sort((a,b)=>order.indexOf(a) - order.indexOf(b))
            }
            
            let cols
            let showHeader = true
            for(const rowName of rows){
                let row = data[rowName]
                if( row ){
                    const rowConfig = sectionInfo.rows?.[rowName] ?? {title: rowName}
                    
                    if(rowConfig.skip){continue}

                    if(!Array.isArray(row) ){
                        row = Object.keys(row).map(d=>({column_name: sectionInfo.rows?.[2] ?? d, value: row[d]}))
                        showHeader = false
                    }
                    if(!cols){
                        cols = row.map(d=>d.column_name)
                        if( sectionInfo.columns?.order){
                            if( sectionInfo.columns?.order === "TTM_QTRS"){
                                let qtrs = cols.filter(d=>d !== "TTM")
                                let sorted = qtrs.sort((a,b)=>new Date(b) - new Date(a))
                                cols = ["TTM", ...sorted]
                            }
                        }
                        out = (showHeader ? "||" : "|") + cols.join("|") + "|\n"
                    }

                    let name = typeof(rowConfig) === "string" ? rowConfig : rowConfig.title


                    out += showHeader ? `|${name}|` : "|"
                    out += cols.map(c=>{
                        let v = row.find(d=>d.column_name === c)?.value ?? "" 
                        if( rowConfig.format === "currency"){
                            let asFloat = parseFloat(v)
                            if( !isNaN(asFloat) ){
                                if( sectionInfo.columns?.order === "TTM_QTRS"){
                                    if( c !== "TTM"){
                                        asFloat *= 1000
                                    }
                                }
                                v = " " + roundCurrency( asFloat)
                            }
                        }else if( rowConfig.format === "number"){
                            const asFloat = parseFloat(v)
                            if( !isNaN(asFloat) ){
                                v = " " + formatNumber( asFloat)
                            }
                        }
                        return v
                    }).join("|") + "|\n"
                    validRows += row.find(d=>d.value && d.value.trim() != "-" ) ? 1 : 0
                }else{
                    if( cols ){
                        out += "|" + cols.map(c=>"-").join("|") + "|\n"
                    }
                }
            }
        }
        if( validRows ){
            if(tables > 0){
                overall += "\n"
            }
            let title = sectionInfo.title ?? section
            overall += title + "\n" + "-".repeat(title.length) + "\n"
            overall += out
            tables ++ 
        }

    }
    return overall
}

export function buildFieldExtractMarkdownTable({
  items = [],
  hints,
  fieldDefs,
  includeItemLabel = true,
  compact = true,
} = {}) {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const normalizedHints = Array.isArray(hints)
    ? hints.map((entry) => (typeof entry === "string" ? entry.trim() : "")).filter(Boolean)
    : [];
  const defs = Array.isArray(fieldDefs) && fieldDefs.length
    ? fieldDefs
        .map((def) => {
          if (!def) return null;
          if (typeof def === "string") {
            return { key: def.split(".").filter(Boolean).slice(-1)[0] || def, path: def };
          }
          if (typeof def === "object") {
            const path = def.path ?? def.value ?? def.field ?? def.key ?? def.name;
            if (!path) return null;
            const key = def.key ?? def.name ?? def.label ?? def.alias ?? path.split(".").pop();
            return { key, path };
          }
          return null;
        })
        .filter(Boolean)
    : normalizedHints.map((hint) => {
        const key = hint.split(".").filter(Boolean).slice(-1)[0] || hint;
        return { key, path: hint };
      });

  if (!defs.length) {
    return null;
  }

  const rows = [];
  const scalarColumns = [];
  const scalarColumnSet = new Set();
  const sharedTimeSeries = new Map();
  const timeSeriesByField = new Map();

  const ensureScalarColumn = (label) => {
    if (!label || scalarColumnSet.has(label)) return;
    scalarColumnSet.add(label);
    scalarColumns.push(label);
  };

  const formatLargeNumber = (value) => {
    if (typeof value !== "number" || !Number.isFinite(value)) {
      return value;
    }
    const abs = Math.abs(value);
    if (Number.isInteger(value) && value >= 1900 && value <= 2100) {
      return value;
    }
    if (abs < 1000) {
      return value;
    }
    return formatNumber(value);
  };

  const flattenStructuredSummaryValue = (
    node,
    allowHeadings = true,
    headerLevel = 0,
    first = true,
  ) => {
    if (!node) {
      return "";
    }
    if (typeof node === "string") {
      return node.trim();
    }
    if (!Array.isArray(node) && typeof node !== "object") {
      return String(node);
    }
    let out = "";
    for (const key in node) {
      const entry = node?.[key];
      if (!entry || typeof entry !== "object") {
        continue;
      }
      if (entry.heading) {
        if (allowHeadings) {
          const hLevel = Math.min(headerLevel + 1, 6);
          out += `${"#".repeat(hLevel)} ${entry.heading}\n`;
        }
      }
      if (typeof entry.content === "string" && entry.content.trim()) {
        if (entry?.type?.match?.(/list/) || entry.content.trim().startsWith("- ")) {
          const lines = entry.content
            .trim()
            .split(/\n/)
            .map((line) => {
              const trimmed = line.trim();
              if (!trimmed) {
                return "";
              }
              return trimmed.startsWith("- ") ? trimmed : `- ${trimmed}`;
            })
            .filter(Boolean);
          out += `${lines.join("\n")}\n`;
        } else {
          out += `${entry.content}\n`;
        }
      }
      if (entry.subsections) {
        out += `${flattenStructuredSummaryValue(
          entry.subsections,
          allowHeadings,
          headerLevel + 1,
          false,
        )}\n`;
      }
    }
    return first ? out.trim() : out;
  };

  const resolveFieldExtractionValue = (item, rawPath) => {
    if (!rawPath || typeof rawPath !== "string") return undefined;
    const path = rawPath.trim();
    if (!path) return undefined;
    if (path === "context" || path === "primitive.context") {
      return item?.context;
    }
    const prefixResolvers = [
      { prefix: "referenceParameters.", target: item?.referenceParameters ?? {} },
      { prefix: "primitive.", target: item },
      { prefix: "data.", target: item?.data ?? {} },
    ];
    let base = item?.referenceParameters ?? {};
    let trimmedPath = path;
    for (const resolver of prefixResolvers) {
      if (path.startsWith(resolver.prefix)) {
        base = resolver.target;
        trimmedPath = path.slice(resolver.prefix.length);
        break;
      }
    }
    if (!trimmedPath) return base;
    const segments = trimmedPath.split(".").filter(Boolean);
    let current = base;
    for (const segment of segments) {
      if (current === undefined || current === null) return undefined;
      current = current[segment];
    }
    return current;
  };

  const parseTimeValue = (timeKey, display) => {
    const candidate = timeKey || display;
    if (!candidate || typeof candidate !== "string") return null;
    const isoMatch = candidate.match(/^\\d{4}-\\d{2}-\\d{2}/);
    if (isoMatch) {
      const parsed = Date.parse(isoMatch[0]);
      return Number.isNaN(parsed) ? null : parsed;
    }
    const parsed = Date.parse(candidate);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const parseYearBucket = (text) => {
    if (!text || typeof text !== "string") return null;
    const trimmed = text.trim();
    if (!trimmed) return null;
    const fyMatch = trimmed.match(/^(FY|FYE)\\s?(\\d{2,4})$/i);
    if (fyMatch) {
      const raw = fyMatch[2];
      const num = Number.parseInt(raw, 10);
      if (!Number.isFinite(num)) return null;
      if (raw.length === 2) {
        return 2000 + num;
      }
      return num;
    }
    const yearMatch = trimmed.match(/^\\d{4}$/);
    if (yearMatch) {
      return Number.parseInt(yearMatch[0], 10);
    }
    const isoMatch = trimmed.match(/^\\d{4}-\\d{2}-\\d{2}/);
    if (isoMatch) {
      return Number.parseInt(isoMatch[0].slice(0, 4), 10);
    }
    const parsed = Date.parse(trimmed);
    if (!Number.isNaN(parsed)) {
      return new Date(parsed).getFullYear();
    }
    return null;
  };

  const resolveTimeBucket = (entry) => {
    const timeLabel =
      entry.point_in_time_raw ??
      entry.point_in_time_iso ??
      entry.point_in_time ??
      entry.period ??
      entry.date ??
      null;
    if (!timeLabel) {
      return null;
    }
    const timeKey = entry.point_in_time_iso ?? timeLabel;
    const display = entry.point_in_time_raw ?? timeLabel;
    const sortValue = parseTimeValue(`${timeKey}`, `${display}`);
    if (!compact) {
      return {
        bucketKey: `${timeKey}`,
        display: `${display}`,
        sortValue,
      };
    }
    const year = parseYearBucket(`${display}`) ?? parseYearBucket(`${timeKey}`);
    if (!year) {
      return {
        bucketKey: `${timeKey}`,
        display: `${display}`,
        sortValue,
      };
    }
    return {
      bucketKey: `${year}`,
      display: `${year}`,
      sortValue: Number.isFinite(sortValue) ? sortValue : year,
    };
  };

  const prefersDisplay = (current, next) => {
    if (!current) return next;
    if (!next) return current;
    if (current === next) return current;
    const isoPattern = /^\\d{4}-\\d{2}-\\d{2}/;
    if (isoPattern.test(current) && !isoPattern.test(next)) {
      return next;
    }
    return current;
  };

  const extractValue = (value, key) => {
    if (value == null) {
      return { type: "empty", columns: [], cells: {} };
    }
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      const formatted = typeof value === "number" ? formatLargeNumber(value) : value;
      return { type: "scalar", columns: [key], cells: { [key]: `${formatted}` } };
    }
    if (Array.isArray(value)) {
      const flat = value
        .filter((entry) => entry != null)
        .map((entry) => (typeof entry === "object" ? JSON.stringify(entry) : `${entry}`));
      return { type: "scalar", columns: [key], cells: { [key]: flat.join(", ") } };
    }
    if (typeof value === "object") {
      const isStructuredSummaryField =
        typeof key === "string" &&
        (key === "structured_summary" || key.endsWith(".structured_summary"));
      if (isStructuredSummaryField) {
        const flattened = flattenStructuredSummaryValue(value);
        return { type: "scalar", columns: [key], cells: { [key]: flattened } };
      }
      const series = Array.isArray(value.values) ? value.values : null;
      if (series && series.length > 0) {
        const entries = [];
        for (const entry of series) {
          if (!entry || typeof entry !== "object") continue;
          const currency = entry.currency ?? value.currency ?? "";
          const numeric = entry.value ?? entry.amount ?? entry.metric ?? entry.total ?? "";
          const maybeNumber = typeof numeric === "number" ? formatLargeNumber(numeric) : numeric;
          const formatted = `${maybeNumber}${currency ? ` ${currency}` : ""}`;
          const bucket = resolveTimeBucket(entry);
          if (!bucket) continue;
          entries.push({
            timeKey: bucket.bucketKey,
            display: bucket.display,
            sortValue: bucket.sortValue,
            value: formatted,
          });
        }
        return { type: "timeseries", entries };
      }
      const parts = Object.entries(value)
        .map(([childKey, childValue]) => {
          if (childValue == null) return null;
          if (typeof childValue === "object") {
            return `${childKey}: ${JSON.stringify(childValue)}`;
          }
          return `${childKey}: ${childValue}`;
        })
        .filter(Boolean);
      return { type: "scalar", columns: [key], cells: { [key]: parts.join("; ") } };
    }
    return { type: "scalar", columns: [key], cells: { [key]: `${value}` } };
  };

  const resolveItemLabel = (item) =>
    item?.title ??
    item?.name ??
    item?.referenceParameters?.name ??
    item?.referenceParameters?.companyName ??
    item?.referenceParameters?.company ??
    item?.referenceParameters?.company_name ??
    item?.plainId ??
    item?.id ??
    "";

  const rawRows = items.map((item) => {
    const row = {};
    const itemLabel = resolveItemLabel(item);
    if (itemLabel) {
      row.__itemLabel = itemLabel;
    }
    for (const def of defs) {
      row[def.key] = resolveFieldExtractionValue(item, def.path);
    }
    return row;
  });

  const singleEntityFieldRowsMode = rawRows.length === 1 && defs.length > 1;
  if (singleEntityFieldRowsMode) {
    const normalizeCell = (value) => {
      if (value == null) {
        return "";
      }
      return String(value).replace(/\r?\n+/g, "<br>").trim();
    };
    const labelForField = (key) => {
      if (typeof key !== "string" || !key.trim().length) {
        return "Field";
      }
      return key;
    };
    const row = rawRows[0] ?? {};
    const fieldRows = [];
    const periodRegistry = new Map();
    let hasScalarValue = false;

    defs.forEach((def) => {
      const parsed = extractValue(row[def.key], def.key);
      const fieldRow = { Field: labelForField(def.key) };
      if (parsed.type === "timeseries") {
        parsed.entries.forEach((entry) => {
          const col = `${entry.display}`;
          fieldRow[col] = entry.value;
          const existing = periodRegistry.get(col);
          const nextSort = Number.isFinite(entry.sortValue) ? entry.sortValue : null;
          if (existing === undefined || (nextSort !== null && nextSort >= existing)) {
            periodRegistry.set(col, nextSort);
          }
        });
      } else {
        const scalarValue = parsed.columns
          .map((col) => parsed.cells?.[col])
          .filter((value) => value !== undefined && value !== null && `${value}`.trim().length > 0)
          .join("; ");
        if (scalarValue) {
          fieldRow.Value = scalarValue;
          hasScalarValue = true;
        }
      }
      fieldRows.push(fieldRow);
    });

    const periodColumns = Array.from(periodRegistry.entries())
      .sort((a, b) => {
        const aSort = a[1];
        const bSort = b[1];
        if (Number.isFinite(aSort) && Number.isFinite(bSort)) {
          return aSort - bSort;
        }
        if (Number.isFinite(aSort)) return -1;
        if (Number.isFinite(bSort)) return 1;
        return a[0].localeCompare(b[0]);
      })
      .map(([label]) => label);

    const columnOrder = ["Field", ...periodColumns, ...(hasScalarValue ? ["Value"] : [])];
    if (columnOrder.length <= 1) {
      return null;
    }
    const header = `| ${columnOrder.join(" | ")} |`;
    const separator = `| ${columnOrder.map(() => "---").join(" | ")} |`;
    const body = fieldRows.map((entry) => `| ${columnOrder.map((col) => normalizeCell(entry[col])).join(" | ")} |`);
    return [header, separator, ...body].join("\n");
  }

  const useItemLabel = includeItemLabel && rawRows.some((row) => row.__itemLabel);
  if (useItemLabel) {
    ensureScalarColumn("Item");
  }

  const timeseriesKeys = new Set();
  rawRows.forEach((row) => {
    for (const def of defs) {
      const value = row[def.key];
      if (value && typeof value === "object" && Array.isArray(value.values)) {
        timeseriesKeys.add(def.key);
      }
    }
  });
  const allowTimeSeriesPrefix = timeseriesKeys.size > 1;

  rawRows.forEach((row) => {
    const cells = {};
    const cellSort = {};
    if (useItemLabel) {
      cells["Item"] = row.__itemLabel ?? "";
    }
    for (const def of defs) {
      const parsed = extractValue(row[def.key], def.key);
      if (parsed.type === "timeseries") {
        const registry = allowTimeSeriesPrefix
          ? (timeSeriesByField.get(def.key) ?? new Map())
          : sharedTimeSeries;
        parsed.entries.forEach((entry) => {
          const existing = registry.get(entry.timeKey) ?? null;
          registry.set(entry.timeKey, {
            display: prefersDisplay(existing?.display, entry.display),
            sortValue: Number.isFinite(entry.sortValue) ? entry.sortValue : existing?.sortValue ?? null,
          });
          const label = allowTimeSeriesPrefix ? `${def.key} ${entry.display}` : `${entry.display}`;
          const currentSort = cellSort[label];
          const nextSort = Number.isFinite(entry.sortValue) ? entry.sortValue : null;
          if (currentSort === undefined || (nextSort !== null && nextSort >= currentSort)) {
            cells[label] = entry.value;
            if (nextSort !== null) {
              cellSort[label] = nextSort;
            }
          }
        });
        if (allowTimeSeriesPrefix) {
          timeSeriesByField.set(def.key, registry);
        }
        continue;
      }
      parsed.columns.forEach((label) => ensureScalarColumn(label));
      Object.assign(cells, parsed.cells);
    }
    rows.push(cells);
  });

  const timeseriesColumns = [];
  const sortTimeEntries = (entries) =>
    entries.sort((a, b) => {
      const aSort = a.sortValue;
      const bSort = b.sortValue;
      if (Number.isFinite(aSort) && Number.isFinite(bSort)) {
        return aSort - bSort;
      }
      if (Number.isFinite(aSort)) return -1;
      if (Number.isFinite(bSort)) return 1;
      return a.display.localeCompare(b.display);
    });

  if (allowTimeSeriesPrefix) {
    defs.forEach((def) => {
      const registry = timeSeriesByField.get(def.key);
      if (!registry || registry.size === 0) return;
      const entries = sortTimeEntries(
        Array.from(registry.entries()).map(([timeKey, meta]) => ({
          timeKey,
          display: meta.display ?? timeKey,
          sortValue: meta.sortValue ?? null,
        })),
      );
      entries.forEach((entry) => {
        timeseriesColumns.push(`${def.key} ${entry.display}`);
      });
    });
  } else if (sharedTimeSeries.size > 0) {
    const entries = sortTimeEntries(
      Array.from(sharedTimeSeries.entries()).map(([timeKey, meta]) => ({
        timeKey,
        display: meta.display ?? timeKey,
        sortValue: meta.sortValue ?? null,
      })),
    );
    entries.forEach((entry) => {
      timeseriesColumns.push(entry.display);
    });
  }

  const columnOrder = [...scalarColumns, ...timeseriesColumns];
  if (!columnOrder.length) {
    return null;
  }

  const header = `| ${columnOrder.join(" | ")} |`;
  const separator = `| ${columnOrder.map(() => "---").join(" | ")} |`;
  const normalizeCell = (value) => {
    if (value == null) {
      return "";
    }
    return String(value).replace(/\r?\n+/g, "<br>").trim();
  };
  const body = rows.map((row) => `| ${columnOrder.map((col) => normalizeCell(row[col])).join(" | ")} |`);
  return [header, separator, ...body].join("\n");
}

export function cartesianProduct(arrays) {
  return arrays.reduce((acc, curr) => {
    const result = [];
    for (const combo of acc) {
      for (const item of curr) {
        result.push([...combo, item]);
      }
    }
    return result;
  }, [[]]); 
}

const normalizeCompareInput = (value) => {
  if (value == null) {
    return '';
  }
  let normalized = String(value);
  if (typeof normalized.normalize === 'function') {
    normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  }
  return normalized
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]/g, '');
};

export function compareTwoStrings(first, second) {
  // https://github.com/aceakash/string-similarity#readme
  const normalizedFirst = normalizeCompareInput(first);
  const normalizedSecond = normalizeCompareInput(second);

  if (normalizedFirst === normalizedSecond) return 1; // identical or empty
  if (normalizedFirst.length < 2 || normalizedSecond.length < 2) return 0; // if either is a 0-letter or 1-letter string

  const firstBigrams = new Map();
  for (let i = 0; i < normalizedFirst.length - 1; i++) {
    const bigram = normalizedFirst.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }

  let intersectionSize = 0;
  for (let i = 0; i < normalizedSecond.length - 1; i++) {
    const bigram = normalizedSecond.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;

    if (count > 0) {
      firstBigrams.set(bigram, count - 1);
      intersectionSize++;
    }
  }

  return (2.0 * intersectionSize) / (normalizedFirst.length + normalizedSecond.length - 2);
}


export function deepEqualIgnoreOrder(a, b) {
    if (a === b) return true;
    if (a == null || b == null || typeof a !== typeof b) return false;
  
    // Array-as-set comparison
    if (Array.isArray(a)) {
      if (!Array.isArray(b)) return false;
      const setA = new Set(a);
      const setB = new Set(b);
      if (setA.size !== setB.size) return false;
      for (const x of setA) {
        if (!setB.has(x)) return false;
      }
      return true;
    }
  
    // Object comparison
    if (typeof a === 'object') {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
      for (const key of keysA) {
        if (!(key in b) || !deepEqualIgnoreOrder(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }
  
    return false;
  }
  export function findFilterMatches(arr,target){
    if( !arr ){
      return []
    }
    const testArr = arr.map(d=>{
      const {title, ...toKeep} = d
      return toKeep
    })
    const {title, ...baseTarget} = target
    const testTarget = Object.fromEntries( Object.entries(baseTarget ?? {}).filter(d=>d[1]) )
    return findMatches(testArr, testTarget)
  }
  
  function findMatches(arr, target) {
    if( !arr ){
      return []
    }
    return arr.find(item => deepEqualIgnoreOrder(item, target));
  }
export function modiftyEntries(obj, entry, callback) {

    if( !callback || !obj){
        return obj
    }
    // Check if the object has a 'heading' key and delete it
    if (obj.hasOwnProperty(entry)) {
        const result = callback( obj )
        obj[entry] = result
    }
    
    // Loop through each key-value pair in the object
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (Array.isArray(obj[key])) {
                // If the value is an array, loop through its items
                obj[key].forEach(item => {
                if (typeof item === 'object') {
                    modiftyEntries(item, entry, callback)
                }
                });
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                // If the value is an object, recurse into it
                modiftyEntries(obj[key], entry, callback)
            }
        }
    }
    return obj
 }
export function convertVisualizationToPrimitiveConfig({source, title, layout, filters, x_axis, y_axis, palette, metadata} ){
    let columnAxis = convertVisualizationAxis( x_axis, metadata)
    let rowAxis = convertVisualizationAxis( y_axis, metadata)
    let viewFilters = filters ? [...filters] : []
    let displayType = "default"
    
    switch( layout ){
        case "pie":
        case "bar":
        case "timeline": 
            displayType = "subchart"
            break
    }
    const renderConfigurationIdx = metadata.renderConfig.explore.configs.findIndex(d=>d.builtIn === "subchart")
    const palette_name = palette?.palette_name

    const selectPalette = palette_name ? {
        "green": "green",
        "red": "heat",
        "heat": "heat",
        "scale": "default",
        "ice": "ice_blue"
          }[palette_name.toLowerCase()]  : undefined

    const renderConfig = {
        style: layout,
        colors: selectPalette ?? "default",
        order: "high_to_low"
    }
    
    const axis = [
        columnAxis,
        rowAxis
    ].filter(d=>d.type !== "none")
    const slices = axis.shift()
    

    if( layout === "pie" || layout === "bar"){
        if( slices ){
            viewFilters.unshift(slices)
            columnAxis = axis[0] ??  {type: "none", filter: []}
            rowAxis = axis[1] ??  {type: "none", filter: []}
        }
    }

    const referenceParameters = {
                                    "target": "items",
                                    "referenceId": metadata.id,
                                    "descend": true,
                                    "explore": {
                                        "view": renderConfigurationIdx,
                                        "axis":{
                                          "column": columnAxis,
                                          "row": rowAxis,
                                        },
                                        "filterTrack": 1,
                                    }
                                }
    if( viewFilters.length > 0){
        const filters = viewFilters.map((d,i)=>{
            return {
                filterTrack: i,
                ...d
            }
        })
        referenceParameters.explore.filters = filters
        referenceParameters.explore.filterTrack = filters.length
    }

    console.log( renderConfig )
    console.log( referenceParameters )
    return {renderConfig, referenceParameters}

}

function mapParameter( def ){
  if( !def ){
    return "title"
  }
    const field = def.field ?? def.parameter
    if( field === "title"){
      return field
    }
    return `params.${field}`
}

function convertVisualizationAxis(def){
  
    let axis = {type: "none", filter: []}
    if( def ){
        const field = def.field ?? def.parameter ?? def.category
        if( def.category_prompt ){
          axis = {
            type: "category",
            toPrepare:{
              prompt: def.category_prompt,
              number: def.number ?? 8,
              parameter: mapParameter(field)
            }
          }

        }else if( def.type === "category" || isObjectId(field) ){
            axis = {
                type: "category", 
                primitiveId: field
            }
        }else if( def.type === "structured_summary"){
            axis = {
                type: "structured_summary",
                parameter: def.parameter ?? def.field,
            }
        }else{
            if( def.operator === "sum" || def.operator === "count"){

            }else{
                axis = {
                    type: "parameter", 
                    parameter: mapParameter(field),
                }
                if( def.values ?? def.value){
                    axis.invert = true
                    axis.filter = def.values ?? def.value
                }
            }
        }
    }
    return axis
}
